import { createAsyncThunk } from '@reduxjs/toolkit';
import { serializeError } from 'shared/utils/redux';
import { headlinesApi } from 'container/headlinesApi';
import { HeadlinesDepartmentsListResultModel } from 'api/dto/new/Headlines/HeadlinesDepartment.dto';

import { STORE_NAME } from './initialState';

export const fetchHeadlinesDepartments = createAsyncThunk<
  HeadlinesDepartmentsListResultModel,
  { surveyId: string }
>(
  `${STORE_NAME}/fetchHeadlinesDepartments`,
  ({ surveyId }) => headlinesApi.getDepartments(surveyId),
  { serializeError }
);
